import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Highlighter from '../highlighter';
import withEnvironment from '../../hoc/with-environment';
import styles from './post-title.scss';

const renderTitle = (title, to, Link) => {
  return to ?
    <object type="communities/link">
      <Link to={to} style={{ color: 'inherit' }}>
        {title}
      </Link>
    </object> :
    <span>{title}</span>;
};

const PostTitle = ({ title, type, query, className, to, component: Component, navigation: { Link } }) => {
  const containerClassName = classNames(styles.title, styles[type], className, 'forum-text-color', 'post-title');
  return (
    <Component className={containerClassName} data-hook="post-title" tabIndex="0">
      {renderTitle(query ? <Highlighter text={title} query={query}/> : title, to, Link)}
    </Component>
  );
};

PostTitle.SMALL = 'small';
PostTitle.MEDIUM = 'medium';
PostTitle.LARGE = 'large';
PostTitle.SINGLE = 'single';
PostTitle.SEARCH = 'search';
PostTitle.MEMBERS_AREA = 'membersArea';

PostTitle.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  query: PropTypes.string,
  className: PropTypes.string,
  to: PropTypes.string,
  component: PropTypes.any,
  navigation: PropTypes.object,
};

PostTitle.defaultProps = {
  component: 'h2',
};

export default withEnvironment({ navigation: 'navigation' })(PostTitle);



// WEBPACK FOOTER //
// ./app/components/post-title/post-title.js